import { Group, Text, Tooltip } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

/** Carries prose that would otherwise take a paragraph on a shared page. */
interface InfoHintProps {
  label: string;
}

export function InfoHint({ label }: InfoHintProps) {
  return (
    <Tooltip label={label} withArrow multiline w={280}>
      <Text component="span" c="dimmed" style={{ display: "inline-flex" }}>
        <IconInfoCircle size={13} />
      </Text>
    </Tooltip>
  );
}

/** Small caps label for a block inside the muscle card. */
interface BlockCaptionProps {
  title: string;
  hint?: string;
}

export function BlockCaption({ title, hint }: BlockCaptionProps) {
  return (
    <Group justify="space-between" align="center" gap="xs" wrap="wrap">
      <Group gap={4} wrap="nowrap">
        <Text fz="xs" fw={700} tt="uppercase" c="dimmed">
          {title}
        </Text>
        {hint && <InfoHint label={hint} />}
      </Group>
    </Group>
  );
}
